import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App.jsx';
import reportWebVitals from './reportWebVitals';
import { initConsent } from './utils/consent';
import { initGA, initGoogleAds, initPostHog, captureUTM } from './utils/analytics';

// Initialize Google Consent Mode v2 BEFORE any gtag/ads/analytics tags so
// defaults are recorded and updates flow through correctly.
initConsent();

// Initialize analytics
initGA();
initGoogleAds();
initPostHog();
captureUTM();

const container = document.getElementById('root');

// react-snap prerenders the marketing pages at build time and inlines the
// resulting HTML into index.html. When that happens the #root element already
// has children and we should hydrate rather than re-mount, which preserves
// the prerendered HTML for crawlers and avoids a flash on first paint.
const tree = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

if (container.hasChildNodes()) {
  hydrateRoot(container, tree);
} else {
  createRoot(container).render(tree);
}

// Send web vitals to Google Analytics
reportWebVitals(({ id, name, value }) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', name, {
      event_category: 'Web Vitals',
      event_label: id,
      value: Math.round(name === 'CLS' ? value * 1000 : value),
      non_interaction: true,
    });
  }
}); 